export default `
  <div class="wb-doc-page">
    <div class="doc-main-title">申请注销盈宝账号</div>

    <div class="doc-text doc-pb28">
      注销账号是不可恢复的操作，为保护您的合法权益，请务必谨慎操作，如您已确定要注销账号，请联系
      <a class="doc-link" href="javascript:void(0);">在线客服</a>
      或致电人工客服进行注销操作。
    </div>

    <div class="doc-text">客服热线：+852 23709538</div>
  </div>
`
